import { styled } from '@mui/system'
import { colors, fontSizes, BORDER_RADIUSES } from '../../Constants/consts'

// export const SearchConStyle = styled('div')(({ theme }) => ({
//   display: 'flex',
//     flexDirection: 'row',
//     justifyContent: 'center',
//     alignItems: 'center'
// }))

// export const SearchStyle = styled('div')(({ theme }) => ({
//   position: 'relative',
//     margin: '5px 10px 0 auto',
//     width: '25%',
//     [theme.breakpoints.down('sm')]: {
//       width: '80%',
//       margin: '10px auto',
//     },
// }))

// Search Container & Input //

export const SearchWrapper = styled('div')<{ $isExpanded?: boolean }>(
  ({ theme, $isExpanded }) => ({
    position: 'relative',
    width: $isExpanded ? '60%' : 350,
    marginLeft: 'auto',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    transition: 'width 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      width: '98vw',
      marginLeft: '1%',
      padding: 0,
    },
  })
)

export const SearchInputContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  backgroundColor: colors.white,
  borderRadius: BORDER_RADIUSES.medium,
  padding: '12px 16px',
  transition: 'all 0.2s ease',
  overflow: 'hidden',
  '&:focus-within': {
    boxShadow: '0 0 0 2px rgba(7, 100, 166, 0.2)',
  },
})

export const SearchIcon = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors.gray.gray60,
  flexShrink: 0,
})

export const SearchInputField = styled('input')({
  flex: 1,
  minWidth: 0,
  border: 'none',
  outline: 'none',
  backgroundColor: 'transparent',
  fontSize: fontSizes.medium,
  color: colors.text,
  textOverflow: 'ellipsis',
  '&::placeholder': {
    color: colors.gray.gray60,
  },
})

export const ClearButton = styled('button')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 4,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  borderRadius: '50%',
  flexShrink: 0,
  transition: 'background-color 0.15s ease',
  '&:hover': {
    backgroundColor: colors.gray.gray20,
  },
})

export const ClearIcon = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors.gray.gray60,
})

// Modal Container //

export const ModalBackdrop = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'transparent',
  zIndex: 999,
})

export const ModalContainer = styled('div')<{
  $maxHeight?: string
  $mobileTop?: string
}>(({ theme, $maxHeight, $mobileTop }) => ({
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  marginTop: 8,
  backgroundColor: colors.white,
  borderRadius: BORDER_RADIUSES.semiLarge,
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
  maxHeight: $maxHeight || '80vh',
  overflowY: 'auto',
  overscrollBehavior: 'contain',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': {
    width: '8px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-track': {
    background: colors.offWhite,
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: colors.gray.gray20,
    borderRadius: '4px',
    '&:hover': {
      background: colors.gray.gray60,
    },
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${colors.gray.gray20} ${colors.offWhite}`,
  zIndex: 1000,
  [theme.breakpoints.down('sm')]: {
    position: 'fixed',
    top: $mobileTop || '80px',
    left: '1%',
    right: '1%',
    maxHeight: $maxHeight || 'calc(100vh - 100px)',
  },
}))

// Tab Bar //

export const TabBarContainer = styled('div')({
  display: 'flex',
  gap: 4,
  padding: '12px 16px',
  borderBottom: `1px solid ${colors.gray.gray20}`,
  overflowX: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
})

export const TabButton = styled('button')<{ $isActive: boolean }>(
  ({ $isActive, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '8px 14px',
    borderRadius: 20,
    border: 'none',
    backgroundColor: $isActive ? colors.text : 'transparent',
    color: $isActive ? colors.white : colors.gray.gray70,
    fontSize: fontSizes.small,
    fontWeight: 500,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: $isActive ? colors.text : colors.pageBackground,
    },
    '&:focus': {
      outline: `none`,
      outlineOffset: 2,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '4px 8px',
    },
  })
)

export const TabCount = styled('span')<{ $isActive: boolean }>(({ $isActive }) => ({
  fontSize: fontSizes.xSmall,
  fontWeight: 600,
  padding: '2px 6px',
  borderRadius: 10,
  backgroundColor: $isActive ? 'rgba(255,255,255,0.2)' : colors.gray.gray20,
  color: $isActive ? colors.white : colors.gray.gray70,
}))

export const ChevronIcon = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'currentColor',
})

// ==========================================
// Category Section
// ==========================================

export const CategoryContainer = styled('div')({
  padding: '16px 16px 8px',
})

export const CategoryHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 12,
})

export const CategoryTitle = styled('h4')({
  margin: 0,
  fontSize: fontSizes.small,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  color: colors.gray.gray70,
})

export const ViewAllButton = styled('button')({
  padding: 0,
  border: 'none',
  background: 'none',
  fontSize: fontSizes.small,
  fontWeight: 500,
  color: colors.blue,
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
  '&:focus': {
    outline: `2px solid ${colors.blue}`,
    outlineOffset: 2,
  },
})

export const CategoryList = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
})

// Result Row //

export const ResultRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '10px 12px',
  borderRadius: BORDER_RADIUSES.small,
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  '&:hover': {
    backgroundColor: colors.pageBackground,
  },
  '&:focus': {
    outline: `2px solid ${colors.blue}`,
    outlineOffset: -2,
  },
})

export const ResultAvatar = styled('img')({
  width: 40,
  height: 40,
  borderRadius: '50%',
  objectFit: 'cover',
  flexShrink: 0,
})

export const ResultThumbnail = styled('img')({
  width: 40,
  height: 'auto',
  borderRadius: BORDER_RADIUSES.xSmall,
  objectFit: 'cover',
  flexShrink: 0,
})

export const ResultLogo = styled('img')({
  width: 40,
  height: 40,
  objectFit: 'contain',
  flexShrink: 0,
})

export const ResultInfo = styled('div')({
  flex: 1,
  minWidth: 0,
})

export const ResultName = styled('span')(({ theme }) => ({
  display: 'block',
  fontSize: fontSizes.medium,
  fontWeight: 600,
  color: colors.text,
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.small,
  },
}))

export const ResultMeta = styled('span')({
  display: 'block',
  fontSize: fontSizes.small,
  color: colors.gray.gray60,
  marginTop: 2,
})

export const ResultChevron = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors.gray.gray40,
  flexShrink: 0,
})

// Shop Grid Items //

export const ShopGridContainer = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: 12,
  padding: '0 16px 16px',
})

export const ShopGridItem = styled('div')<{ $isGridView?: boolean }>(
  ({ $isGridView }) => ({
    display: 'flex',
    flexDirection: $isGridView ? 'column' : 'row',
    alignItems: $isGridView ? 'flex-start' : 'center',
    gap: $isGridView ? 8 : 12,
    padding: $isGridView ? 12 : '10px 12px',
    backgroundColor: $isGridView ? colors.pageBackground : 'transparent',
    borderRadius: BORDER_RADIUSES.small,
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: $isGridView ? colors.gray.gray20 : colors.pageBackground,
    },
    '&:focus': {
      outline: `2px solid ${colors.blue}`,
      outlineOffset: -2,
    },
  })
)

export const ShopProductImage = styled('img')<{ $isGridView?: boolean }>(
  ({ $isGridView }) => ({
    width: $isGridView ? '100%' : 48,
    height: $isGridView ? 100 : 48,
    borderRadius: BORDER_RADIUSES.xSmall,
    objectFit: 'contain',
    backgroundColor: colors.white,
    flexShrink: 0,
  })
)

export const ShopProductInfo = styled('div')({
  flex: 1,
  minWidth: 0,
})

export const ShopProductTitle = styled('span')<{ $isGridView?: boolean }>(
  ({ $isGridView }) => ({
    display: '-webkit-box',
    WebkitLineClamp: $isGridView ? 2 : 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    fontSize: $isGridView ? fontSizes.small : fontSizes.medium,
    fontWeight: 600,
    color: colors.text,
  })
)

export const ShopProductPrice = styled('span')({
  display: 'block',
  fontSize: fontSizes.small,
  fontWeight: 600,
  color: colors.text,
  marginTop: 4,
})

export const ShopProductAction = styled('span')<{ $isGridView?: boolean }>(
  ({ $isGridView }) => ({
    display: $isGridView ? 'none' : 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.gray.gray40,
    flexShrink: 0,
  })
)

// Highlighting //

export const HighlightMark = styled('mark')({
  backgroundColor: colors.yellow,
  color: colors.text,
  padding: '0 2px',
  borderRadius: 2,
})

// Empty & Loading States //

export const EmptyState = styled('div')({
  padding: 32,
  textAlign: 'center',
  color: colors.gray.gray60,
  fontSize: fontSizes.medium,
})

export const SearchLoadingContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 32,
})

export const SearchLoadingText = styled('div')({
  color: colors.gray.gray60,
  fontSize: fontSizes.medium,
})
